import Modal from 'components/commons/modal'
import icDownloadPrimary from '../../../assets/images/ic-download-primary.svg'
import icFileUp from '../../../assets/images/ic-file-up-02.svg'
import icFilter from '../../../assets/images/ic-filter-new.svg'
import { TABLE_PAYROLL_DETAIL } from '../../../configs/payroll/configTablePayrollList'
import { findOptionSelected } from '../../../utils/utils'
import Button from '../../commons/button'
import { ExportModal } from '../../commons/ExportModal'
import Search from '../../commons/search'
import Select from '../../commons/select'
import Table from '../../commons/table'
import Toast from '../../commons/toast'

export const PayrollDetail = ({
    dataList,
    columnTable,
    isLoading,
    query,
    optionsFilter,
    isShowToast,
    toastMessage,
    showModal,
    setModal,
    onExport,
    clearToast,
    onChangeQuery,
    onDownloadPayslip,
    selectedItems,
    setSelectedItems,
}) => {
    return (
        <div className={'flex flex-col'}>
            <div className={'flex items-center justify-between gap-3 px-6 py-4'}>
                <div className={'flex space-x-7'}>
                    <Search value={query?.search} onSearch={(search) => onChangeQuery({ page: 1, search })} />
                    <div className={'flex gap-3'}>
                        <div className={'flex items-center gap-2'}>
                            <img src={icFilter} alt='ic-filter' />
                            <p className='text-neutral-70'>Filter by Department:</p>
                            <Select
                                name='department_id'
                                className='w-[300px]'
                                optionsClassName='max-h-40'
                                placeholder='Pilih Department'
                                options={optionsFilter}
                                value={
                                    findOptionSelected(optionsFilter, Number(query?.department_id)) || optionsFilter[0]
                                }
                                onChange={(item) => onChangeQuery({ page: 1, [item?.name]: item?.value?.value })}
                                searchable
                            />
                        </div>
                        <Button
                            title='Export'
                            icon={icFileUp}
                            type='outline'
                            disabled={!dataList?.total_result}
                            onClick={() => setModal({ export: true })}
                        />
                    </div>
                </div>
                <Button
                    type='outline'
                    title='Download Payslip'
                    icon={icDownloadPrimary}
                    disabled={!dataList?.total_result}
                    onClick={() => setModal({ download: true })}
                />
            </div>
            <Table
                className='my-3'
                name={TABLE_PAYROLL_DETAIL.name}
                columns={columnTable}
                data={dataList?.result?.data}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickSort={(val) => onChangeQuery(val)}
                onSelectItem={setSelectedItems}
                loading={isLoading}
            />
            <ExportModal
                title='Apakah anda yakin ingin export data payroll detail?'
                description={`Total data payroll detail export: ${selectedItems?.length || dataList?.result?.data?.length}`}
                show={showModal?.export}
                onExportHandler={onExport}
                onCancelHandler={() => setModal({ export: false })}
            />

            {/* Download Payslip */}
            <Modal dialogClassName='w-full max-w-[328px]' contentClassName='rounded-xl' show={showModal?.download}>
                <div>
                    <div className={'py-8 px-6 flex flex-col justify-center items-center space-y-4'}>
                        <p className={'text-center font-semibold'}>Apakah anda yakin ingin download data payroll?</p>
                        <p
                            className={'text-center text-neutral-70 whitespace-pre-line'}
                        >{`Total data payroll: ${selectedItems?.length || dataList?.total_result}`}</p>
                    </div>
                    <div className={'px-6 py-3 flex flex-row border-t space-x-3 justify-center'}>
                        <Button type={'outline'} title={'Cancel'} onClick={() => setModal({ download: false })} />
                        <Button title={'Download'} onClick={onDownloadPayslip} />
                    </div>
                </div>
            </Modal>

            <Toast show={isShowToast} message={toastMessage} onClose={() => clearToast()} />
        </div>
    )
}
